function updateProductVariant() {
  var map = document.querySelector('[data-variant-map]');
  if (!map) return;
  var selectors = Array.from(document.querySelectorAll('[data-product-option]'));
  var selected = selectors.map(function (selector) { return selector.value; });
  var variant = Array.from(map.options).find(function (option) {
    return selected.every(function (value, index) {
      return option.getAttribute('data-option' + (index + 1)) === value;
    });
  });
  var price = document.querySelector('[data-price]');
  var button = document.querySelector('[data-add-to-cart]');
  var status = document.querySelector('[data-variant-status]');

  if (!variant) {
    map.value = '';
    if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
    if (status) status.textContent = 'This combination is unavailable. Choose another option.';
    return;
  }

  map.value = variant.value;
  map.dispatchEvent(new Event('change', { bubbles: true }));
  if (price && variant.dataset.price) price.textContent = variant.dataset.price;
  var available = variant.dataset.available === 'true';
  if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; }
  if (status) status.textContent = available ? '' : 'This option is sold out. Choose another option.';
}

var favoritesKey = 'oceancart:favorites';
var favoritesOpener = null;
function readFavorites() {
  try {
    var value = JSON.parse(window.localStorage.getItem(favoritesKey) || '[]');
    return Array.isArray(value) ? value.filter(function (item) { return item && typeof item.id === 'string' && typeof item.title === 'string'; }) : [];
  } catch (error) { return []; }
}

function saveFavorites(items) {
  try { window.localStorage.setItem(favoritesKey, JSON.stringify(items)); } catch (error) { /* Favorites remain usable for this page view. */ }
  renderFavorites();
}

function renderFavorites() {
  var items = readFavorites();
  document.querySelectorAll('[data-favorites-count]').forEach(function (count) { count.textContent = String(items.length); });
  document.querySelectorAll('[data-favorite-toggle]').forEach(function (button) {
    var saved = items.some(function (item) { return item.id === button.dataset.productId; });
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + (button.dataset.productTitle || 'product') + (saved ? ' from' : ' to') + ' favorites');
  });

  var list = document.querySelector('[data-favorites-list]');
  if (!list) return;
  list.replaceChildren();
  if (!items.length) {
    var empty = document.createElement('p');
    empty.className = 'favorites-drawer__empty';
    empty.textContent = 'You haven’t saved any products yet. Tap the heart on a product to keep it here.';
    list.appendChild(empty);
    return;
  }
  items.forEach(function (item) {
    var row = document.createElement('article');
    row.className = 'favorite-item';
    if (item.image) {
      var imageLink = document.createElement('a');
      imageLink.href = item.url || '#';
      var image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      imageLink.appendChild(image);
      row.appendChild(imageLink);
    }
    var details = document.createElement('div');
    details.className = 'favorite-item__details';
    var titleLink = document.createElement('a');
    titleLink.href = item.url || '#';
    titleLink.textContent = item.title;
    details.appendChild(titleLink);
    if (item.price) {
      var price = document.createElement('p');
      price.textContent = item.price;
      details.appendChild(price);
    }
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'favorite-item__remove';
    remove.dataset.favoriteRemove = item.id;
    remove.textContent = 'Remove';
    details.appendChild(remove);
    row.appendChild(details);
    list.appendChild(row);
  });
}

function setFavoritesOpen(open) {
  var drawer = document.querySelector('[data-favorites-drawer]');
  if (!drawer) return;
  drawer.hidden = !open;
  document.body.classList.toggle('favorites-open', open);
  if (open) {
    favoritesOpener = document.activeElement;
    renderFavorites();
    var panel = drawer.querySelector('.favorites-drawer__panel');
    if (panel) panel.focus();
  } else if (favoritesOpener && typeof favoritesOpener.focus === 'function') favoritesOpener.focus();
}

document.addEventListener('change', function (e) {
  if (e.target.closest('[data-product-option]')) updateProductVariant();
  var sort = e.target.closest('[data-collection-sort]');
  if (sort) {
    var collectionUrl = new URL(window.location.href);
    collectionUrl.searchParams.set('sort_by', sort.value);
    collectionUrl.searchParams.delete('page');
    window.location.assign(collectionUrl.toString());
    return;
  }
  var qty = e.target.closest('[data-cart-qty]');
  if (qty) qty.form.submit();
});

document.addEventListener('keydown', function (e) {
  var discountInput = e.target.closest('[data-discount-code]');
  if (discountInput && e.key === 'Enter') {
    e.preventDefault();
    var applyButton = discountInput.closest('[data-discount-box]')?.querySelector('[data-apply-discount]');
    if (applyButton) applyButton.click();
  }
});

document.addEventListener('click', function (e) {
  var galleryThumb = e.target.closest('[data-gallery-thumb]');
  if (galleryThumb) {
    var gallery = galleryThumb.closest('[data-product-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-gallery-main]');
    if (mainImage) {
      mainImage.src = galleryThumb.dataset.imageSrc;
      mainImage.dataset.imageZoom = galleryThumb.dataset.imageZoom;
      mainImage.alt = galleryThumb.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        var active = thumb === galleryThumb;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }
    return;
  }

  var galleryZoom = e.target.closest('[data-gallery-zoom]');
  if (galleryZoom) {
    var dialog = document.querySelector('[data-gallery-dialog]');
    var sourceImage = galleryZoom.querySelector('[data-gallery-main]');
    var dialogImage = dialog && dialog.querySelector('[data-gallery-dialog-image]');
    if (dialog && sourceImage && dialogImage && typeof dialog.showModal === 'function') {
      dialogImage.src = sourceImage.dataset.imageZoom || sourceImage.src;
      dialogImage.alt = sourceImage.alt;
      dialog.showModal();
    }
    return;
  }

  var galleryClose = e.target.closest('[data-gallery-close]');
  if (galleryClose) {
    var openGalleryDialog = galleryClose.closest('[data-gallery-dialog]');
    if (openGalleryDialog) openGalleryDialog.close();
    return;
  }

  if (e.target.matches('[data-gallery-dialog]')) { e.target.close(); return; }

  var tabButton = e.target.closest('[data-tab-target]');
  if (tabButton) {
    var tabRoot = tabButton.closest('[data-tabs]');
    if (tabRoot) {
      tabRoot.querySelectorAll('[data-tab-target]').forEach(function (tab) {
        var selected = tab === tabButton;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(tab.dataset.tabTarget);
        if (panel) panel.hidden = !selected;
      });
    }
    return;
  }

  var favoriteToggle = e.target.closest('[data-favorite-toggle]');
  if (favoriteToggle) {
    var items = readFavorites();
    var productId = favoriteToggle.dataset.productId;
    var existingIndex = items.findIndex(function (item) { return item.id === productId; });
    if (existingIndex >= 0) items.splice(existingIndex, 1);
    else items.push({ id: productId, title: favoriteToggle.dataset.productTitle || 'Product', url: favoriteToggle.dataset.productUrl || '#', image: favoriteToggle.dataset.productImage || '', price: favoriteToggle.dataset.productPrice || '' });
    saveFavorites(items);
    return;
  }

  if (e.target.closest('[data-favorites-open]')) { setFavoritesOpen(true); return; }
  if (e.target.closest('[data-favorites-close]')) { setFavoritesOpen(false); return; }
  var favoriteRemove = e.target.closest('[data-favorite-remove]');
  if (favoriteRemove) {
    saveFavorites(readFavorites().filter(function (item) { return item.id !== favoriteRemove.dataset.favoriteRemove; }));
    return;
  }

  var quantityButton = e.target.closest('[data-quantity-change]');
  if (quantityButton) {
    var quantity = quantityButton.parentElement.querySelector('[data-cart-qty]');
    if (!quantity) return;
    var nextValue = Math.max(0, (parseInt(quantity.value, 10) || 0) + parseInt(quantityButton.dataset.quantityChange, 10));
    quantity.value = nextValue;
    quantity.form.submit();
    return;
  }

  var applyDiscount = e.target.closest('[data-apply-discount]');
  if (applyDiscount) {
    var discountBox = applyDiscount.closest('[data-discount-box]');
    var discountInput = discountBox && discountBox.querySelector('[data-discount-code]');
    var status = discountBox && discountBox.querySelector('[data-discount-status]');
    var code = discountInput && discountInput.value.trim();
    if (!code) {
      if (status) status.textContent = 'Enter a discount code to apply it.';
      return;
    }
    var baseUrl = discountBox.dataset.discountBase || '/discount/';
    var cartUrl = discountBox.dataset.cartUrl || '/cart';
    window.location.assign(baseUrl + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl));
  }
});

document.addEventListener('DOMContentLoaded', function () {
  updateProductVariant();
  renderFavorites();
  document.addEventListener('keydown', function (event) {
    var drawer = document.querySelector('[data-favorites-drawer]:not([hidden])');
    if (!drawer) return;
    if (event.key === 'Escape') { setFavoritesOpen(false); return; }
    if (event.key === 'Tab') {
      var focusable = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]')).filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = Array.from(root.querySelectorAll('[data-tab-target]'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var step = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(index + step + tabs.length) % tabs.length];
        next.focus();
        next.click();
      });
    });
  });
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.querySelectorAll('.card').forEach(function (productCard) {
    productCard.classList.add('card--interactive');
    if (reducedMotion || !finePointer) return;
    productCard.addEventListener('pointermove', function (event) {
      var rect = productCard.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width;
      var y = (event.clientY - rect.top) / rect.height;
      productCard.style.setProperty('--card-y', ((x - 0.5) * 5).toFixed(2) + 'deg');
      productCard.style.setProperty('--card-x', ((0.5 - y) * 4).toFixed(2) + 'deg');
      productCard.style.setProperty('--card-lift', '-3px');
    }, { passive: true });
    productCard.addEventListener('pointerleave', function () {
      productCard.style.setProperty('--card-x', '0deg');
      productCard.style.setProperty('--card-y', '0deg');
      productCard.style.setProperty('--card-lift', '0px');
    }, { passive: true });
  });

  var stage = document.querySelector('[data-tilt-stage]');
  var card = stage && stage.querySelector('[data-tilt-card]');
  if (!stage || !card || reducedMotion || !finePointer) return;

  stage.addEventListener('pointermove', function (event) {
    var rect = stage.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;
    var rotateY = (x - 0.5) * 13;
    var rotateX = (0.5 - y) * 11;
    card.style.setProperty('--tilt-x', rotateX.toFixed(2) + 'deg');
    card.style.setProperty('--tilt-y', rotateY.toFixed(2) + 'deg');
  }, { passive: true });

  stage.addEventListener('pointerleave', function () {
    card.style.setProperty('--tilt-x', '0deg');
    card.style.setProperty('--tilt-y', '0deg');
  }, { passive: true });
});
